import React from 'react';
import './NewFooter.scss';
import logoImg from "../../Assets/images/protikares.png";
import {LocSVG, SmallSVG} from "./FooterSVG";
import {Link} from "react-router-dom";

const NewFooter = ({footerData}) => {

  const items = [
    {link: "صفحه اصلی", path: "/", id: "main"},
    {link: "دسته بندی", path: "/group", id: "group"},
    {link: " بلاگ", path: "/blog", id: "blog"},
    {link: " درباره ما", path: "./aboutUs", id: "aboutUs"},
    {link: "تماس با ما", path: "./callWithUs", id: "callWithUs"}
  ];

  const EnamadSection = {
    href: "https://trustseal.enamad.ir/?id=377405&Code=jK7U96DKFlPHD8pcwdeD",
    src: "https://trustseal.enamad.ir/logo.aspx?id=377405&Code=jK7U96DKFlPHD8pcwdeD",
    code: "jK7U96DKFlPHD8pcwdeD",
  }

  const SamandehiNamad = {
    href: "https://logo.samandehi.ir/Verify.aspx?id=362784&p=xlaogvkauiwkjyoemcsiaods",
    src: "https://logo.samandehi.ir/logo.aspx?id=362784&p=qftiwlbqodrfyndtaqgwshwl",
    code: "rgvjfukznbqejzpeoeukwlao",
  }

  try {
    return (
      <footer className="main-footer-new">

        <div className="content-side">

          <div className="f-one">
            <img src={logoImg} alt=" لوگو" className="logo-pic"/>

            <p>{footerData?.footerText}</p>

            <div className="address-text">
              <LocSVG/>
              <p>{footerData?.footerAddress}</p>
            </div>

          </div>

          <div className="f-two">

            <ul>
              <h4>لینک ها</h4>
              {items.map((v, index) =>
                <li key={"L" + index}>
                  <SmallSVG/>
                  <Link to={v.path}>{v.link}</Link>
                </li>
              )}
            </ul>

            {footerData?.links.length > 0 &&
              <ul>
                <h4>راههای ارتباطی</h4>
                {footerData?.links.map((v, index) =>
                  <li key={"R" + index}>
                    <img src={v.icon} alt={"Link"}/>
                    <a target='_blank' href={v.link}>{v.title}</a>
                  </li>
                )}
              </ul>}


          </div>

          <div className="f-three">

            <a referrerPolicy='origin' target='_blank' href={EnamadSection.href}>
              <img referrerPolicy='origin'
                   src={EnamadSection.src}
                   alt='اینماد'
                   style={{cursor: 'pointer'}}
                   Code={EnamadSection.code}
                   id={EnamadSection.code}/>
            </a>

            <a referrerPolicy='origin' target='_blank' href={SamandehiNamad.href}>
              <img referrerPolicy='origin'
                   src={SamandehiNamad.src}
                   alt='ساماندهی'
                   style={{cursor: 'pointer'}}
                   Code={SamandehiNamad.code}
                   id={SamandehiNamad.code}/>
            </a>

            {footerData?.license.length > 0 &&
              footerData?.license.map((v) =>
                <img src={v.image} alt={"license"}/>
              )
            }
          </div>
        </div>

        <div className="link-side">
          <h6>دانلود اپلیکیشن پروتیکا</h6>
          <div className="current-link">
            {footerData?.downloadLink.length > 0 &&
              footerData?.downloadLink.map((v) =>
                <div className="box-link">
                  <a href={v.link}>
                    <img src={v.icon} alt={"link"}/>
                  </a>
                </div>
              )
            }
          </div>
        </div>

        <div className="bottom-side">
          <h5>تمامی حقوق این وبسایت متعلق به شرکت پروتیکا می باشد</h5>
        </div>

      </footer>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default NewFooter;